import { PaymentItem } from './../models/paymentItem';
import { Commission } from './../models/commission';
import { CheckProviderData } from './../models/check-provider-data';
import { ProviderItemInputs } from './../models/provider-item-inputs';
import { ProviderInfo } from './../models/provider-info';
import { QueryResult } from './../models/query-result';
import { ProviderInput } from './../models/provider-input';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { actionUrl, handleError, getHeaders } from '../util/common';
import { Provider } from '../models/provider';
import { ProviderDetails } from '../models/provider-details';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class ProvidersService {
  constructor(private http: HttpClient) { }

  private providerDetail: ProviderDetails;
  private providerItemInputs: ProviderItemInputs[];
  private currency: string;
  private sessionData: ProviderItemInputs;

  public getProviders(id: string | null): Observable<any> {
    const url = `${actionUrl}/getProviders`
    return this.http.post<Provider[]>(url, { 'PaymentProviderGroupGUID': id }, getHeaders(true)).pipe(
      map(provider => provider),
      catchError(handleError<any>(`id = ${id} not found`))
    );
  }

  public getProviderInputs(id: string): Observable<any> {
    const url = `${actionUrl}/GetProviderInputs`
    return this.http.post<Provider[]>(url, { 'ProviderGUID': id }, getHeaders(true)).pipe(
      map(providerInput => providerInput),
      catchError(handleError<any>(`id = ${id} not found`))
    );
  }

  public getProviderInfo(id: string): Observable<any> {
    const url = `${actionUrl}/GetProviderInfo/?guid=${id}`
    return this.http.get<QueryResult[]>(url, getHeaders(true)).pipe(
      map(providerInfo => providerInfo),
      catchError(handleError<any>(`id = ${id} not found`))
    );
  }

  public checkProviderItemInputs(providerItemInputs: ProviderItemInputs[]): Observable<any> {
    const url = `${actionUrl}/CheckProviderItemInputs`;
    return this.http.post<ProviderDetails>(url, { 'Items': providerItemInputs }, getHeaders(true)).pipe(
      map(providerDetails => {
        this.providerDetail = providerDetails;
        this.providerItemInputs = providerItemInputs;
        this.sessionData = providerDetails.SessionData ? new ProviderItemInputs(providerDetails.SessionData[0][0], providerDetails.SessionData[0][1]) : null;
        return providerDetails;
      }),
      catchError(handleError<any>(` not found`))
    );
  }

  public getCommissions(id: string, currency: string): Observable<any> {
    const url = `${actionUrl}/GetCommissions`
    return this.http.post<Commission[]>(url, {
      ProviderGUID: id,
      Currency: currency
    }, getHeaders(true)).pipe(
      map(commission => commission),
      catchError(handleError<any>(`id = ${id} not found`))
    );
  }

  public getItem(id: string): Observable<any> {
    const url = `https://publicservice.evoca.am/api/CustomPayment/GetItem/${id}`
    return this.http.get<PaymentItem>(url, getHeaders(false)).pipe(
      map(paymentItem => paymentItem),
      catchError(handleError<any>(`id = ${id} not found`))
    );
  }

  public setCurrency(currency: string) {
    this.currency = currency;
  }

  public getCurrency() {
    return this.currency;
  }

  public getProviderDetails(): CheckProviderData {
    return new CheckProviderData(this.providerDetail, this.providerItemInputs);
  }

  public getSessionData(): ProviderItemInputs {
    return this.sessionData;
  }
}
